import { render, staticRenderFns } from "./StatisticCardVerticalIndex.vue?vue&type=template&id=3f2e2f48&"
import script from "./StatisticCardVerticalIndex.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports